'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Native HTML textarea element.
 *
 * @example
 * <Textarea />
 */
const Textarea = forwardRef(function Textarea({ className, ...rest }, ref) {
    return (jsx("textarea", { className: cl('ds-input', className), ref: ref, ...rest }));
});

export { Textarea };
